import { if_undefined } from "./math_functions.js"
import { Exception_value } from "./exception_value.js"


/*
selector: switch
variable:
    operator: super_element_match
branches:
    - condition: "solar"
      simple_value:
      <solar>Solar: <solar_debuff>x{$1} Scorch</solar_debuff>.</solar>
    - condition: "void"
      simple_value:
      <void>Void: <void_debuff>Weaken</void_debuff> for 4 seconds.</void>
    ....

selector: if
branches:
    - condition:
        operator: super_element_match
        left: solar
      simple_value:
      <solar>Solar: <solar_debuff>x{$1} Scorch</solar_debuff>.</solar>
    - condition:
        operator: super_element_match
        left: arc
      simple_value:
      <arc>Arc: <arc_debuff>Blind</arc_debuff> for <value>{$2}</value> seconds.</arc>
    ....

selector
{
    fields:
        type
        variable (type == "if") ? operator : null
        conditions[]
        current_simple_value

    methods:
        reset
        apply
        get_value
        check_condition
        get_type
}
*/

export function Simple_value_constructor(master, data)
{
    if ("selector" in data)
        return new Selector(master, data);
    else if ("value" in data)
        return new Simple_value(master, data);
    else
    {
        throw Error("error occurred in Simple_value_constructor(), data is not Selector or Simple_value");
    }
}

function exec_switch(obj)
{
    let value = obj.calculate_formula(obj.variable);

    console.log("switch var:", value)

    for (let branch of obj.branches)
    {
        console.log(":::::::::::::::", value, branch.condition, value == branch.condition);
        if (value == branch.condition)
        {
            obj.current_simple_value = branch.simple_value;
            break;
        }
    }
}

function exec_if(obj)
{
    for (let branch of obj.branches)
    {
        if (obj.check_condition(branch.condition))
        {
            console.log("if true branch", branch)
            obj.current_simple_value = branch.simple_value;
            break;
        }
    }
}

class Selector
{
    constructor(master, data)
    {
        this.master = master;
        this.current_simple_value = null;

        if ("selector" in data && (data.selector == "if" || data.selector == "switch"))
            this.type = data.selector;
        else
        {
            throw Error("Selector type is missed or is not 'if' or 'switch', data:", data, "master:", this.master);
        }

        if (this.type == "switch")
        {
            if ("variable" in data)
                this.variable = data.variable
            else
               throw Error("switch-Selector does not have variable, data:", data, "master:", this.master);
        }
        else
            this.variable = null;

        if ("branches" in data)
        {
            this.branches = new Array();

            for (let [i, branch] of Object.entries(data.branches))
            {
                //console.log(branch)
                // TODO: check if try needed
                this.branches.push(
                    {
                        condition: branch.condition,
                        simple_value: new Simple_value(this.master, branch.simple_value)
                    }
                );
            }

            this.current_simple_value = this.branches[0].simple_value; //TODO: rework
        }
        else
            throw Error("conditions must be in Selector definition, data:", data, "master:", this.master);

        if (this.type == 'if')
            this.exec_strategy = exec_if;
        else
            this.exec_strategy = exec_switch;
    }

    check_condition(condition)
    {
        return this.master.check_condition(condition);
    }

    calculate_formula(formula)
    {
        return this.master.calculate_formula(formula);
    }

    reset(stack)
    {
        this.exec_strategy(this);
        this.current_simple_value.reset(stack);
    }

    apply(other)
    {
        this.current_simple_value.apply(other);
    }

    get_rounded_value()
    {
        return this.current_simple_value.get_rounded_value();
    }

    get_type()
    {
        return this.current_simple_value.get_type();
    }

    get_value()
    {
        return this.current_simple_value.get_value();
    }

    set_value(new_value)
    {
        this.current_simple_value.set_value(new_value);
    }

    get_template_index()
    {   // TODO: maybe let template_index be stored in selector?
        return this.current_simple_value.get_template_index();
    }

    get_relates_to()
    {
        return this.current_simple_value.get_relates_to();
    }

    get_default_value()
    {
        return this.current_simple_value.get_default_value();
    }
    
    get_exceptions()
    {
        return this.current_simple_value.get_exceptions();
    }
}

/*
    Simple_value
    {
        fields:
            master
            type
                [add|assign|mul|percent_increase  |  formula  |  stat|string]
                operators:
                    add|assign|mul|percent_increase
                changeable_values
                    stat|string|formula
            stacking_type [array/sum/mul] sum - default
            relates_to
            template_index
            exceptions
            label
            decorator
            decimals

        methods:
            reset
            apply
            get_value
            get_type
            -check_condition
    }
*/

class Simple_value
{
    constructor(master, data)
    {
        this.master = master;
        this.type = data.type;

        if ("stacking_type" in data)
            this.stacking_type = data.stacking_type;
        else if (Array.isArray(data.value))
            this.stacking_type = "array";
        else
            this.stacking_type = "sum";

        if (this.stacking_type == "array")
        {
            this.default_value = data.value.slice();
            this.value =  data.value[0];
        }
        else
        {
            this.default_value = data.value;
            this.value = data.value;
        }

        this.is_attribute = if_undefined(data, "is_attribute", "");

        this.relates_to = ('relates_to' in data) ? data.relates_to : null;
        this.decimals = ('decimals' in data) ? data.decimals : null;
        this.template_index = ('template_index' in data) ? data.template_index : null;
        this.decorator = ('decorator' in data) ?  data.decorator : null;
        this.label = ('label' in data) ? data.label :  null;

        this.exceptions = null;
        if ('exceptions' in data)
        {
            this.exceptions = new Map();
            for (let label in data.exceptions)
                this.exceptions.set(
                    label,
                    new Exception_value(data.exceptions[label], this)
                );
        }
    }

    reset(stack) // TODO: add stacking strategy
    {
        if (this.type == "string")
        {
            if (this.stacking_type == "array")
                this.value = this.default_value[stack - 1];
            else
                this.value = this.default_value;
        }
        else if (this.stacking_type == "array")
            this.value = this.default_value[stack - 1];
        else if(this.stacking_type == "sum")
            this.value = this.default_value * stack;
        else if (this.stacking_type == "mul")
        {
            if (this.type == "percent_increase")
                this.value = (Math.pow(this.default_value / 100 + 1, stack) - 1) * 100;
            else
                this.value = Math.pow(this.default_value, stack);
        }
        else if (this.stacking_type == "nostack")
        {
            this.value = this.default_value;
        }
        else if (this.type != 'formula')
        {
            this.value = this.default_value;
        }
    }

    /*
        Three conditions
        (A) this.label == null
        (B) other.get_exceptions() == null
        (C) other.get_exceptions() has this.label
        but cannot check (B) and (C) simultaneously

        8 total variants
             A   B   C
        0.   0   0   0
        1.   0   0   1 -> This is the only variant when exceptional effect happen. Others follow regular way
        2.   0   1   0
        3.   0   1   1
        4.   1   0   0
        5.   1   0   1
        6.   1   1   0
        7.   1   1   1

        by checking (A) this.label == null variants (4 - 8) are true
        by checking (B) other.get_exceptions() == null variants (2, 3, 6, 7) are true
        so (this.label == null || other.get_exceptions() == null) takes variants (2 - 7)
        so then only need to check (C)
        seems javascript works different from C, os it is allowed to check B&C at the same time
        TODO rewrite if needed
    */
    apply(other) // other is another Simple_value
    {
        //console.log(this.label, other.get_exceptions());
        if (this.label == null || other.get_exceptions() == null)
        {
            //console.log('Regular way 1');
            var other_effect = other;
        }
        else
        {
            if (other.get_exceptions().has(this.label))
            {
                //console.log('Exceptional way');
                var other_effect = other.get_exceptions().get(this.label);
            }
            else
            {
                //console.log('Regular way 2');
                var other_effect = other;
            }
        }

        console.log(this,other_effect.get_type(), other_effect);

        if (other_effect.get_type() == 'mul')
        {
            this.value *= other_effect.get_value();
        }
        if (other_effect.get_type() == 'add')
        {
            this.value += other_effect.get_value();
        }
        if (other_effect.get_type() == 'percent_increase')
        {
            this.value *= (other_effect.get_value() / 100 + 1);
        }
        if (other_effect.get_type() == 'assign')
        {
            this.value = other_effect.get_value();
        }
    }

    get_rounded_value() // TODO: rounding strategy
    {
        let return_value;

        if (this.decimals != null && (this.type == 'stat' || this.type == 'formula'))
            return_value = Number(this.value).toFixed(this.decimals);
        else if (this.decimals == null && this.type != 'string')
            return_value = Math.round(this.value);
        else
            return_value = this.value;

        if (this.decorator != null)
            return this.decorator.replace('{{}}', return_value);
        else
            return return_value;
    }

    get_type()
    {
        return this.type;
    }

    get_value()
    {
        return this.value;
    }

    set_value(new_value)
    {
        this.value = new_value;
    }

    get_template_index()
    {
        return this.template_index;
    }

    get_relates_to()
    {
        return this.relates_to;
    }

    get_default_value()
    {
        return this.default_value;
    }
    
    get_exceptions()
    {
        return this.exceptions;
    }
}